var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelpCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9929 29.323C23.3542 29.323 29.3217 23.3555 29.3217 15.9942C29.3217 8.63292 23.3542 2.66541 15.9929 2.66541C8.63158 2.66541 2.66406 8.63292 2.66406 15.9942C2.66406 23.3555 8.63158 29.323 15.9929 29.323Z",
    stroke: "current",
    strokeWidth: 1.99932,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1152 11.9952C12.4286 11.1044 13.0471 10.3532 13.8612 9.87478C14.6754 9.39631 15.6326 9.22141 16.5633 9.38105C17.494 9.54069 18.3382 10.0246 18.9464 10.747C19.5545 11.4694 19.8873 12.3838 19.8859 13.3281C19.8859 15.9939 15.8873 17.3267 15.8873 17.3267",
    stroke: "current",
    strokeWidth: 1.99932,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9932 22.658H16.0075",
    stroke: "current",
    strokeWidth: 1.99932,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpCircle);
export default __webpack_public_path__ + "static/media/help-circle.fea6519c0a6f4e16d130e9a5ee1bc92f.svg";
export { ForwardRef as ReactComponent };